import { useEffect, useRef } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { message } from 'antd'
import { ISelectOptions } from '@/types/AppTypes'
import { YHModal } from '@/components/YHModal'
import { baseTrailerModel } from '../trailerModel'
import { globalPrompt } from '@/components/message'
// import { trailerPowerList } from '@/types/AppEnums'
import { trailerService } from '../trailerService'
import moment from 'moment'
import useGlobalModel from '@/model/globalModel'

export const EditTrailerModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = baseTrailerModel()
    const formRef = useRef<IYhFormRef>()
    const {
        authData,
        user: { userType },
    } = useGlobalModel(({ user }) => [user])
    // const [formVal, setFormVal] = useState<any>({})

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            try {
                let { retData } = await trailerService.edit({
                    ...editCarVisible.value,
                    ...val,
                    registrationDate: moment(val.registrationDate).format('YYYY-MM-DD'),
                })
                setEditCarVisible({
                    visible: false,
                    value: {},
                })
                message.success(`修改成功！`)
                loadData()
                return retData
            } catch (error) {
                message.warning(error)
            }
        })
    }

    useEffect(() => {
        formRef.current?.setFieldsValue({
            ...editCarVisible.value,
            registrationDate: moment(editCarVisible.value.registrationDate),
        })
    }, [editCarVisible.value])
    const vehicleSiteChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ fleet: value })
    }

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
        // setFormVal({ ...formVal, ...val })
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车辆牌照',
                fieldName: 'licensePlate',
                span: 24,
                rules: [{ required: true, message: '请输入车辆牌照' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车辆品牌',
                fieldName: 'trailerBrand',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车型',
                fieldName: 'trailerModel',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '上牌日期',
                fieldName: 'registrationDate',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                span: 24,
            },
            {
                type: userType === '超级管理员' ? FormItemTypeEnum.Select : FormItemTypeEnum.Input,
                fieldLabel: '所属车队',
                fieldName: 'vehicleSite',
                span: 24,
                options: [
                    {
                        label: '全部',
                        value: '',
                        type: '管理员',
                    },
                    ...authData,
                ].filter((item) => item.type === '管理员'),
                onSelectChange: vehicleSiteChange,
                disable: userType !== '超级管理员',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '备注',
                fieldName: 'note',
                span: 24,
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        // formValues: formVal,
        onChange,
        boxs: [formItem],
    }
    const onClose = () => {
        globalPrompt('modal', {
            title: '修改挂车',
            type: 'warning',
            text: '您正在修改的挂车记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {},
                }),
            cancelText: '继续修改',
            // onCancel: () => {
            //     formRef.current?.resetFields()
            //     return
            // },
        })
    }
    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改挂车..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
